import React from 'react';
import { MdOutlineTimer } from 'react-icons/md';
import { Tooltip } from "@mui/material";

const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

const ConditionalIcon = ({ file, roleId }) => {
    if (file.conditionalDeadLine && roleId !== "USER") {
        const conditionalDate = formatDate(file.conditionalDeadLine);
        const termDate = formatDate(file.termOfPermitDate);
        const titleText = (
            <div>
                <ul style={{ margin: 0, padding: '0 0 0 20px', listStyleType: 'circle' }}>
                    <li><strong>პირობის ვადა:</strong> {conditionalDate}</li>
                    <li><strong>ნებართვის ვადა:</strong> {termDate}</li>
                </ul>
            </div>
        );

        return (
            <Tooltip title={titleText}>
                <span style={{ marginLeft: 5 }}>
                    <MdOutlineTimer className="alert-icon-return_comment" />
                </span>
            </Tooltip>
        );
    }
    return null;
};

export default ConditionalIcon;
